import {getCountryCode} from './get-country-code.js';

/**
 * @returns ISO 4217 alphabetic code (e.g `'EUR'`)
 */
export function getCurrency(marketId: string): string {
  const countryCode = getCountryCode(marketId);

  switch (countryCode) {
    case `CH`:
      return `CHF`;
    case `GB`:
      return `GBP`;
    case `SE`:
      return `SEK`;
    default:
      return `EUR`;
  }
}
